import { removeItem, replaceItem } from "../../../common/state/common";
import { IFeatureFamily, ILoadableWrapper, onLoadableLoad, onLoadableSuccess, toLoadableWrapper } from "../../../common/models";

export function addFamily(current: ILoadableWrapper<IFeatureFamily>[], newFamily: IFeatureFamily): ILoadableWrapper<IFeatureFamily>[] {
    if (newFamily == undefined || newFamily.id == undefined) {
        return current;
    }

    return current.concat(toLoadableWrapper(newFamily));
}

export function replaceFamily(current: ILoadableWrapper<IFeatureFamily>[], updated: IFeatureFamily): ILoadableWrapper<IFeatureFamily>[] {
    if (updated == undefined || updated.id == undefined) {
        return current;
    }

    return replaceItem(current, onLoadableSuccess(toLoadableWrapper(updated)));
}

export function setFamilyLoading(current: ILoadableWrapper<IFeatureFamily>[], family: IFeatureFamily): ILoadableWrapper<IFeatureFamily>[] {
    if (family == undefined || family.id == undefined) {
        return current;
    }

    return replaceItem(current, onLoadableLoad(toLoadableWrapper(family)));
}

export function removeFamily(current: ILoadableWrapper<IFeatureFamily>[], removed: IFeatureFamily): ILoadableWrapper<IFeatureFamily>[] {
    if (removed == undefined || removed.id == undefined) {
        return current;
    }

    return removeItem(current, removed.id);
}

export function resetFamilyLoading(current: ILoadableWrapper<IFeatureFamily>[], family: IFeatureFamily): ILoadableWrapper<IFeatureFamily>[] {
    if (family == undefined || family.id == undefined) {
        return current;
    }

    return replaceItem(current, toLoadableWrapper(family));
}

export function clearFamilies(): ILoadableWrapper<IFeatureFamily>[] {
    return [];
}
